import React from "react";
import "./Gallery.css";

const Gallery = () => {
    const handleImageClick = (stadium) => {
        // Navigate to the next page
        window.location.href = `/stadium/${stadium}`;
    };

    return (

        <section className="cricket-gallery-sec11">
            <div className="cricket-gallery-section11">

                <p className="gallery-subtitle11">A Collection of Moments</p>
                <h2 className="gallery-title11">Check Out Our Gallery</h2>

                <div className="gallery-container11">
                    {/* Column 1 */}
                    <div className="gallery-column11">
                        <div className="gallery-item11">
                            <img src="/Images/watch.jpg" alt="Mumbai Stadium" />
                            <div className="gallery-info11">
                                <p>Prize Time</p>
                                <span>Winning Cups</span>
                            </div>
                        </div>
                        <div className="gallery-item11">
                            <img src="/Images/group.jpg" alt="Delhi Stadium" />
                            <div className="gallery-info11">
                                <p>Award Ceremony Group Photo</p>
                                <span>All Winners Together</span>
                            </div>
                        </div>
                    </div>

                    {/* Column 2 */}
                    <div className="gallery-column11">
                        <div className="gallery-item11 large">
                            <img src="/Images/winning.jpg" alt="Chennai Stadium" />
                            <div className="gallery-info11">
                                <p>KKL Festival</p>
                                <span>Celebration Moments</span>
                            </div>
                        </div>
                        <div className="gallery-row11">
                            <div className="gallery-item11 large">
                                <img src="/Images/12 (3).jpg" alt="Chennai Stadium" />
                                <div className="gallery-info11">
                                    <p>MRFC Champions</p>
                                    <span>Season 3</span>
                                </div>
                            </div>
                        </div>
                        <div className="view-all59Playerss11">
                            <button onClick={() => window.location.href = "/AtplGallery"}>View All</button>
                        </div>
                    </div>

                    {/* Column 3 */}
                    <div className="gallery-column11">
                        <div className="gallery-item11">
                            <img src="/Images/price.jpg" alt="Pune Stadium" />
                            <div className="gallery-info11">
                                <p>Prize Ceremony</p>
                                <span>Winning Cups</span>
                            </div>
                        </div>
                        <div className="gallery-item11">
                            <img src="/Images/award.jpg" alt="Hyderabad Stadium" />
                            <div className="gallery-info11">
                                <p>Trophy Celebration</p>
                                <span>Champions Moment</span>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </section>
    );
};

export default Gallery;
